import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { AppState } from '../store.types';
import { publishedBoardEffectsActions } from './published-boards.actions';
import { PublishedBoardState } from './published-boards.types';

export const publishedBoardsInitialState: AppState['publishedBoards'] = {};

export const publishedBoardsReducer = createImmerReducer(
  publishedBoardsInitialState,
  on(publishedBoardEffectsActions.setPublishedBoard, (state, { publishedBoard }) => {
    return { ...state, [publishedBoard.boardId]: publishedBoard };
  }),
  on(publishedBoardEffectsActions.setPublishedBoardData, (state, { boardId, publishedBoardData }) => {
    return { ...state, [boardId]: { ...state[boardId], data: publishedBoardData } };
  }),
  on(publishedBoardEffectsActions.setPublishedBoardModuleData, (state, { boardId, moduleData, module }) => {
    return {
      ...state,
      [boardId]: {
        ...state[boardId],
        moduleData: { ...(<PublishedBoardState>state[boardId]).moduleData, [module]: moduleData },
      },
    };
  }),
  on(publishedBoardEffectsActions.error, (state, { boardId, error }) => {
    return { ...state, [boardId]: error };
  })
);
